// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik MĂśller. fixes from Paul Irish and Tino Zijdel
// MIT license

(function () {
    let lastTime = 0;
    const vendors = ['ms', 'moz', 'webkit', 'o'];
    for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] 
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
    }
})();

(function () {
    function sprite (options) {
        let that = {},
            frameIndex = 0,
            tickCount = 0,
            ticksPerFrame = options.ticksPerFrame || 0,
            numberOfFrames = options.numberOfFrames || 1;
        
        that.context = options.context;
        that.width = options.width;
        that.height = options.height;
        that.image = options.image;
        
        that.update = function () {

            tickCount += 1;

            if (tickCount > ticksPerFrame) {
                tickCount = 0;
                
                // If the current frame index is in range
                if (frameIndex < numberOfFrames - 1) {    
                    // Go to the next frame
                    frameIndex += 1;
                } else {
                    frameIndex = 0;
                }
            }
        };
        
        that.render = function (isFirstTime) {
        
          // Clear the canvas
          that.context.clearRect(0, 0, that.width, that.height);
          
          // Draw the animation
          that.context.drawImage(
            that.image,
            frameIndex * that.width / numberOfFrames,
            0,
            that.width / numberOfFrames,
            that.height,
            0,
            0,
            that.width / numberOfFrames,
            that.height);
        };
        
        return that;
    }

    ///// run all animations
    const animations = $('.js-canvas-sprite-animation');
    const canvasWidth = 750;
    const canvasHeight = 750;
    const supportsTouch = false;

    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;

    for (var i = animations.length - 1; i >= 0; i--) {
        const canvasElement = $(animations[i]);
        let frames = canvasElement.data('frames');
        const animationId = canvasElement.attr('id');
        const spriteImagePath = canvasElement.data('sprite-image');
        const fallback = canvasElement.data('fallback');
        const aninmationCanvasWidth = canvasElement.data('canvas-width') || canvasWidth;
        const aninmationCanvasHeight = canvasElement.data('canvas-height') || canvasHeight;
        const stopCanvasPlayingAfter = canvasElement.data('stop-canvas-playing-after') || false;

        let spriteCanvas,
            spriteImage,
            canvas; 

        // Get canvas
        canvas = document.getElementById(animationId);
        canvas.width = aninmationCanvasWidth;
        canvas.height = aninmationCanvasHeight;

        let animationLoop;

        if (isAndroid) {
            $('<img src="' + fallback + '" alt="">').insertAfter('#' + animationId);
            $(animations[i]).remove();

        } else {
            
            let loadAnimation = function() {
                animationLoop = window.requestAnimationFrame(loadAnimation);
            }
            
            // Create sprite sheet
            spriteImage = new Image();
            
            // Create sprite
            spriteCanvas = sprite({
                context: canvas.getContext("2d"),
                width: frames*aninmationCanvasWidth,
                height: aninmationCanvasHeight,
                image: spriteImage,
                numberOfFrames: frames,
                ticksPerFrame: 1
            });

            spriteImage.src = spriteImagePath;

            // Load sprite sheet
            spriteImage.addEventListener("load", function() {
                spriteCanvas.update();
                spriteCanvas.render();
            });

            $(document).bind( 'runCanvas-' + canvasElement.parents('.js-run-canvas').index(), function(e) {
                if (stopCanvasPlayingAfter) {
                    loadAnimation();


                    setTimeout(function() {
                        window.cancelAnimationFrame(animationLoop);
                    }, stopCanvasPlayingAfter);
                } else {
                    loadAnimation();
                }
            });

            $(document).bind( 'stopCanvas-' + canvasElement.parents('.js-run-canvas').index(), function(e) {
                window.cancelAnimationFrame(animationLoop);
                $(document).unbind( 'runCanvas-' + canvasElement.parents('.js-run-canvas').index());
            });
        }
    }

} ());